export default "__VITE_ASSET__BohuizDD__"